export default function deepEqual(obj1: any, obj2: any): boolean {
  // console.log('deepEqual check', obj1, obj2);

  if (obj1 === obj2)
    // it's just the same object. No need to compare.
    return true;

  // console.log('compare', obj1, obj2);
  if (!obj1 || !obj2) return false;
  if (isPrimitive(obj1) && isPrimitive(obj2)) {
    // console.log('here', obj1, obj2);

    // compare primitives
    return obj1 === obj2;
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    // console.log('here?', obj1, obj2);

    return false;
  }

  // compare objects with same number of keys
  for (const key in obj1) {
    if (!(key in obj2)) return false; //other object doesn't have this prop
    if (!deepEqual(obj1[key], obj2[key])) {
      // console.log('here - result is false');
      return false;
    }
  }

  return true;
}

//check if value is primitive
function isPrimitive(obj: any) {
  return obj !== Object(obj);
}
